var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isShow)?_c('div',{staticClass:"plc-info",on:{"click":_vm.handlePlcClick}},[_c('img',{staticClass:"plc-icon",attrs:{"src":_vm.icon}}),_vm._v(" "),_c('div',{staticClass:"plc-desc"},[_vm._v("\n        "+_vm._s(_vm.desc)+"\n    ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }